<template>
  <w-flex wrap class="justify-space-between">
    <div
      class="xs8 headline text-left pl7 monitoring-title"
    >
      <span>
        <!-- otherwise the anchor element would wrap the icon incrrectly -->
        <router-link
          v-if="from"
          :to="from"
          class="back-link"
        >
          <w-icon class="v-middle" fill-height color="primary">
            mdi mdi-arrow-left
          </w-icon>
        </router-link>
      </span>
      <span> Robots Monitoring </span>
    </div>
    
    <div class="spacer"></div>
    <w-flex wrap class="align-center mx3"> 
      <div class="spacer"></div>
      <span class="center pya mx2"
        >Last Refresh:
        {{
          lastRefresh
            ? timeformatLoc(
                Math.floor(lastRefresh.getTime() / 1000),
                optionsStore.getState().localeBrowser,
                optionsStore.getState().timezoneBrowser
              )
            : lastRefresh
        }}
      </span>
      
    
      <w-button class="mx2" lg @click="refresh()">Refresh</w-button></w-flex
    >
  </w-flex>

  <!-- table data -->
  <PaginationNav :paginationStore="robotsStore"></PaginationNav>
  <div class="mx3">
    <!--table component-->
    <w-table
      class="robot-list"
      hover
      fixed-headers
      :loading="table.loading"
      :headers="table.headers"
      :items="table.items"
      :selectable-rows="1"
      @row-select="(e) => openDetail(e)"
    >
      <template v-slot:[`item-cell.baseStationName`]="{ item }">{{
        item.lastSession ? item.lastSession["baseStationName"] : ""
      }}</template>
      <template v-slot:[`item-cell.lastStatus`]="{ item }">
        <span v-if="item.lastSession"
          ><span :class="conditionalClass(getStatus(item.lastSession.state))">
            {{ getStatus(item.lastSession["state"]) }}</span
          >
          at: {{ dateTimeFormat(item.lastSession["lastUpdate"]) }}</span
        >

        <div v-else class="title4 my1">
          The registered robot has never connected
        </div></template
      >

      <template v-slot:[`item-cell.lastSession`]="{ label }">
        <w-flex v-if="label">
          <table class="title4 my1" max-width>
            <tr
              v-for="row in historyCard({
                start: label.lastConnectionStart,
                stop: label.lastConnectionStop,
              }).rows"
              :key="row.label"
            >
              <td class="text-bold" v-if="row.date">
                {{ row.label }}: &nbsp;&nbsp;
              </td>
              <td v-if="row.date">{{ row.date }} &nbsp;&nbsp;</td>
              <td>
                {{ row.time }}
              </td>
            </tr>
          </table>
        </w-flex>
      </template>
      <template v-slot:[`item-cell.lastSessionDuration`]="{ item }">
        <div v-if="item.lastSession && item.lastSession.lastConnectionStart">
          <span v-if="item.lastSession.lastConnectionStop" class="ml2">
            {{
              getTime(
                item.lastSession.lastConnectionStop -
                  item.lastSession.lastConnectionStart
              )
            }}
          </span>
          <span v-else class="ml2">
            {{ getTime(now - item.lastSession.lastConnectionStart) }}
          </span>
        </div>
      </template>
    </w-table>
  </div>
  <PaginationNav :paginationStore="robotsStore"></PaginationNav>
</template>

<script>
import { robotsStore } from "../store/robots";
import {
  timeformatLoc,
  dateTimeFormat,
  timeformatt,
  dateformatt,
  getTime,
} from "@/utils/time-formatter";
import { getStatus, robotStatusClass } from "@/utils/status"
import { optionsStore } from "@/store/options";
import router from "@/router/index.js";
import {
  ref,
  reactive,
  onMounted,
  watch,
  // computed,
  // , computed,  onUnmounted
} from "vue";
import PaginationNav from "../components/PaginationNav.vue";

export default {
  name: "RobotsView",
  components: { PaginationNav },
  setup: () => {
    const now = ref(new Date().getTime() / 1000);
    var lastRefresh = ref(new Date());
    const isMounted = ref(false);
    const filters = reactive({});
    const table = reactive({
      headers: [
        { label: "IMEI", key: "imei", sortable: false },
        { label: "Base Station", key: "baseStationName", sortable: false },
        { label: "Last Status", key: "lastStatus", sortable: false },
        { label: "Last Session", key: "lastSession", sortable: false },
        { label: "Time Span", key: "lastSessionDuration", sortable: false },
      ],
      items: [],
    });
    function historyCard(item) {
      return {
        headers: [
          { label: "label", key: "label" },
          { label: "date", key: "date" },
          { label: "time", key: "time" },
        ],
        rows: [
          {
            label: "End",
            date: dateformatt(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            time: timeformatt(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
          },
          {
            label: "Start",
            date: dateformatt(
              item.start,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            time: timeformatt(
              item.start,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
          },
        ],
      };
    }
    async function refresh() {
      robotsStore.state.data = await robotsStore.loadData(
        robotsStore.paginationParams,
        await robotsStore.getState().call
      );
      lastRefresh.value = new Date();
      now.value = new Date().getTime() / 1000;
    }
    async function mount() {
      await robotsStore.initPagination();
      if (robotsStore.getIsInitialized()) {
        console.log("is inizialized");
        refresh();
        isMounted.value = true;
      }
    }
    function openDetail(item) {
      console.log(item);
      if(item["item"]["lastSession"]){
      router.push("/robots/" + item["item"]["imei"]);}
    }
    onMounted(() => mount());
    watch(
      () => robotsStore.state.data,
      (data) => {
        table.loading = true;
        table.items = data;
        table.loading = false;
      }
    );


    function conditionalClass(value) {
     return robotStatusClass(value,"px2 py1 text-center")
    }
    return {
      now,
      filters,
      historyCard,
      timeformatLoc,
      dateTimeFormat,
      getTime,
      lastRefresh,
      table,
      optionsStore,
      robotsStore,
      refresh,
      conditionalClass,
      getStatus,
      openDetail,
    };
  },
};
</script>

<style scoped>
.monitoring-title {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
}

.back-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.v-middle {
  vertical-align: middle;
}

.w-table tbody tr:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.04);
}
.robot-list {
  letter-spacing: -0.5px;
  font-family: 'Robot', monospace;
  max-height: 60%;
}
</style>
